import { _ as __assign } from '../../chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { useChannelContext } from '../context.js';
import { G as GroupChannelUIView } from '../../chunks/bundle-C1PaUKxY.js';
import { ChannelHeader } from './ChannelHeader.js';
import { MessageList } from './MessageList.js';
import { MessageInputWrapper } from './MessageInput.js';
import { d as deleteNullish } from '../../chunks/bundle-u-vzK-oc.js';
import '../../chunks/bundle-CfyvTsrV.js';
import '@sendbird/uikit-tools';
import '../../withSendbird.js';
import '../../chunks/bundle-Bd7J49Pj.js';
import '../../chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CXA05pe2.js';
import '../../chunks/bundle-DokyceKk.js';
import '../../chunks/bundle-Dz4_R08c.js';
import 'react-dom';
import '../../chunks/bundle-DWyboFhb.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../chunks/bundle-DtujCCHB.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C4eUm39A.js';
import '../../useSendbirdStateContext.js';
import '../../chunks/bundle-CZybJwCN.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-Cytf5OXn.js';
import '../../chunks/bundle-Bf00X-bc.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-BKmrhRhi.js';
import '../../chunks/bundle-Bytw3a1z.js';
import '../../chunks/bundle-BqOj5e7u.js';
import '../../chunks/bundle-wIpBG4h1.js';
import '../../chunks/bundle-CXcQbCC8.js';
import '../../chunks/bundle-mZUrgg4o.js';
import '../../chunks/bundle-CeFR-WNJ.js';
import '../../chunks/bundle-CK28kSQl.js';
import '../../chunks/bundle-3OW5t08v.js';
import '../../chunks/bundle-CFXlbz6X.js';
import '../../chunks/bundle-DPABwR4A.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../chunks/bundle-B6I7SV-0.js';
import '../../ui/ConnectionStatus.js';
import '../../ui/PlaceHolder.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-CXwDMEak.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../chunks/bundle-ydxNdZ_o.js';
import '../../chunks/bundle-DzMGbPvb.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DmX77DTu.js';
import './Message.js';
import '../../chunks/bundle-BRQfx_hR.js';
import '../../chunks/bundle-Bsdfe5yG.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-DyTMSX7q.js';
import '../../chunks/bundle-CWUQ80OI.js';
import 'dompurify';
import '../../chunks/bundle-BnRVAspH.js';
import '../../chunks/bundle-ySMjorsI.js';
import '../../chunks/bundle-DxT0jQsV.js';
import '../../chunks/bundle-DsnagByW.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-xuXUit3M.js';
import '../../chunks/bundle-CzzanD4i.js';
import '../../chunks/bundle-C12wpwcO.js';
import '../../chunks/bundle-YDVJPPbj.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-Bdc0r0vX.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-DCjrv9Kz.js';
import '../../ui/MobileMenu.js';
import '../../ui/ThreadReplies.js';
import '../../chunks/bundle-DZw8Wfu-.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-C5677rct.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../chunks/bundle-CaWp0im0.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-DoVEdOJ0.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-xG1e3S1C.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../chunks/bundle-Db8gqi-L.js';
import '../../GroupChannel/components/SuggestedReplies.js';
import '../../chunks/bundle-CwopwRQp.js';
import './FileViewer.js';
import '../../chunks/bundle-CD0EW-ph.js';
import './RemoveMessageModal.js';
import '../../chunks/bundle-CunaqP3n.js';
import '../../chunks/bundle-DGskllVK.js';
import '../../GroupChannel/components/UnreadCount.js';
import '../../GroupChannel/components/FrozenNotification.js';
import '../../chunks/bundle-C373kKPf.js';
import '../../chunks/bundle-Dh2SecIj.js';
import '../../ui/TypingIndicatorBubble.js';
import '../../chunks/bundle-Do-Uo0Mj.js';
import '../utils/getMessagePartsInfo.js';
import '../utils/compareMessagesForGrouping.js';
import '../../chunks/bundle-OSl93HLe.js';
import '../../GroupChannel/components/SuggestedMentionList.js';
import '../../ui/QuoteMessageInput.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-rR4UDSt3.js';
import '../../chunks/bundle-CdmtMf8Y.js';

var ChannelUI = function (props) {
    var context = useChannelContext();
    var channelUrl = context.channelUrl, isInvalid = context.isInvalid;
    // Inject components to presentation layer
    var _a = deleteNullish(props), _b = _a.renderChannelHeader, renderChannelHeader = _b === void 0 ? function (p) { return React__default.createElement(ChannelHeader, __assign({}, p)); } : _b, _c = _a.renderMessageList, renderMessageList = _c === void 0 ? function (p) { return React__default.createElement(MessageList, __assign({}, p, { className: "sendbird-conversation__message-list" })); } : _c, _d = _a.renderMessageInput, renderMessageInput = _d === void 0 ? function () { return React__default.createElement(MessageInputWrapper, __assign({}, props)); } : _d;
    return (React__default.createElement(GroupChannelUIView, __assign({}, props, context, { isLoading: props === null || props === void 0 ? void 0 : props.isLoading, isInvalid: isInvalid, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};

export { ChannelUI as default };
//# sourceMappingURL=ChannelUI.js.map
